import { action } from 'typesafe-actions';
import { MotoristaTypes, IMotorista, IDetalhesMotorista, IFilter, Pagination } from './types';

export const loadRequest = (parceiros: number[], filtro?: IFilter | any, pagination?: Pagination) =>
  action(MotoristaTypes.LOAD_REQUEST, { parceiros, filtro, pagination });
export const loadSuccess = (data: IMotorista[], pagination: Pagination) =>
  action(MotoristaTypes.LOAD_SUCCESS, { data, pagination });
export const loadFailure = () => action(MotoristaTypes.LOAD_FAILURE, {});

export const loadDetalhesRequest = (codMotorista: number) =>
  action(MotoristaTypes.LOAD_DETALHES_REQUEST, { codMotorista });
export const loadDetalhesSuccess = (dataDetalhesMotorista: IDetalhesMotorista[]) =>
  action(MotoristaTypes.LOAD_DETALHES_SUCCESS, { dataDetalhesMotorista });
export const loadDetalhesFailure = () => action(MotoristaTypes.LOAD_DETALHES_FAILURE, {});

export const cleanStateMotorista = () => action(MotoristaTypes.CLEAN_MOTORISTA);
export const filter = (filter: any) => action(MotoristaTypes.FILTER, { filter });
